import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd'
import { Button, Grid, makeStyles, Typography } from '@material-ui/core'
import { FieldArray } from 'react-final-form-arrays'
import arrayMutators from 'final-form-arrays'
import FiledDraggable from './FiledDraggable'
import useTranslate from '../../../i18n/useTranslate'
import {
    DocumentResponseSearch,
    SearchDocumentRequest,
    SearchDocumentResponse,
} from '../../../services/um/useSettingDocument'
import { DocumentType } from '../../../pages/SettingDocument'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../router/routesConfig'
import AddIcon from '@material-ui/icons/Add'

const getListStyle = (isDraggingOver: boolean): React.CSSProperties => ({
    margin: '16px 0px',
    width: '100%',
})

type DraggablesProps = {
    handleOrder: (value: DocumentType) => void
    isDragDisabled: boolean
    handleOrderNumberMode: () => void
    dataList?: DocumentResponseSearch
    isExpanded?: boolean
    reLoadData?: (param: SearchDocumentRequest) => void
}

const Draggables = ({
    handleOrder,
    isDragDisabled,
    handleOrderNumberMode,
    dataList,
    isExpanded,
    reLoadData,
}: DraggablesProps): JSX.Element => {
    const classes = useStyles()
    const translate = useTranslate()
    const history = useHistory()

    const onDragEnd = (fields: any, form: any) => (result: DropResult) => {
        if (!result.destination) {
            return
        }
        const items: SearchDocumentResponse[] = reorder(fields.value, result.source.index, result.destination.index)
        form.change('document', items)
    }

    const initialValues = {
        document: dataList?.data,
    }

    const reorder = (
        list: SearchDocumentResponse[],
        startIndex: number,
        endIndex: number,
    ): SearchDocumentResponse[] => {
        const result = Array.from(list)
        const [removed] = result.splice(startIndex, 1)
        result.splice(endIndex, 0, removed)

        return result
    }

    const onClickAdd = () => {
        history.push({
            pathname: RoutePath.settingDocumentAdd,
        })
    }

    return (
        <FinalForm
            onSubmit={handleOrder}
            initialValues={initialValues}
            mutators={{
                ...arrayMutators,
            }}
            render={({ values, handleSubmit, form, submitting, pristine }) => (
                <form onSubmit={handleSubmit}>
                    <>
                        <Grid container justify="space-between" style={{ margin: '15px 0px' }}>
                            <Grid container item xs={12} sm={12} md={6} lg={6}>
                                <Grid item>
                                    <Typography variant="h6">
                                        {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${dataList?.total ?? 0}`])}
                                    </Typography>
                                </Grid>
                                {!isDragDisabled && (
                                    <Grid container item xs={12} sm={12} md={12} lg={12}>
                                        <Grid item xs={12}>
                                            <Typography variant={'subtitle2'} style={{ color: 'red' }}>
                                                * {translate.get('LABEL.DRAGABLE_LABEL')}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <Grid container justify="flex-end" spacing={2}>
                                    {isDragDisabled ? (
                                        <Grid item>
                                            <Button
                                                size="large"
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleOrderNumberMode}
                                            >
                                                <Typography variant="button">
                                                    {translate.get('BUTTON.ORDER')}
                                                </Typography>
                                            </Button>
                                        </Grid>
                                    ) : (
                                        <>
                                            <Grid item>
                                                <Button
                                                    size={'large'}
                                                    variant="contained"
                                                    className={classes.cancelButton}
                                                    onClick={() => {
                                                        handleOrderNumberMode?.()
                                                        return form.reset
                                                    }}
                                                    // disabled={submitting || pristine}
                                                >
                                                    {translate.get('BUTTON.CANCEL')}
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    size={'large'}
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleSubmit}
                                                    disabled={submitting || pristine}
                                                    style={{ minWidth: '0px' }}
                                                >
                                                    {translate.get('BUTTON.SAVE')}
                                                </Button>
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item>
                                        <Button
                                            size="large"
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={onClickAdd}
                                        >
                                            <Typography variant="button">
                                                {translate.get('UM.SETTINGDOCUMENT.SEARCH.ADDBUTTON')}
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <div className={classes.controlFieldArray}>
                            <FieldArray name="document">
                                {({ fields }) => (
                                    <DragDropContext onDragEnd={onDragEnd(fields, form)}>
                                        <Droppable droppableId="droppable">
                                            {(provided, snapshot): JSX.Element => (
                                                <div
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                    style={getListStyle(snapshot.isDraggingOver)}
                                                >
                                                    <FiledDraggable
                                                        dataList={fields.value}
                                                        isDragDisabled={isDragDisabled}
                                                        reLoadData={reLoadData}
                                                    />
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                )}
                            </FieldArray>
                        </div>
                    </>
                </form>
            )}
        />
    )
}

const useStyles = makeStyles((theme) => ({
    controlFieldArray: {
        // height: (props: { isExpanded: boolean }) => {
        //     if (props.isExpanded) {
        //         return '420px'
        //     } else {
        //         return '630px'
        //     }
        // },
        width: '100%',
        // overflowY: 'scroll',
        overflow: 'auto',
        [theme.breakpoints.down('md')]: {
            height: 'auto',
        },
        marginTop: '-15px',
    },

    cancelButton: {
        backgroundColor: '#FFFFFF',
        border: 'solid 1px #db5f8e',
    },
}))

export default Draggables
